import axios from 'axios'
import { MOBILE_NEWSLETTER_URL } from './api'
import { authorizationHelper } from '../common/helpers'

function createFormData(preview_img, main_img, body) {
  const data = new FormData();

  if (preview_img) data.append('photos', preview_img, 'preview_img')
  if (main_img) data.append('photos', main_img, 'main_img')

  Object.keys(body).forEach(key => {
    data.append(key, body[key]);
  });

  return data;
};

export function getAll(page, filter) {
  const params = {
    page,
    filter
  }

  return axios.get(MOBILE_NEWSLETTER_URL, {
    params,
    headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
  })
}

export function get(id) {
  const url = `${MOBILE_NEWSLETTER_URL}/${id}`

  return axios.get(url, {
    headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
  })
}

export function create(newsletter, preview_img, main_img) {
  return axios.post(
    MOBILE_NEWSLETTER_URL,
    createFormData(preview_img, main_img, {
      title: newsletter.title,
      hashTags: newsletter.hashTags,
      short_desc: newsletter.short_desc,
      large_desc: newsletter.large_desc,
    }),
    {
      headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    }
  )
}

export function update(id, newsletter, preview_img, main_img) {
  const url = `${MOBILE_NEWSLETTER_URL}/${id}`

  return axios.put(
    url,
    createFormData(preview_img, main_img, {
      title: newsletter.title,
      hashTags: newsletter.hashTags,
      short_desc: newsletter.short_desc,
      large_desc: newsletter.large_desc,
    }),
    {
      headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function deleteNewsletter(id) {
  const url = `${MOBILE_NEWSLETTER_URL}/${id}`

  return axios.delete(url, {
    headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
  })
}


// WEBPACK FOOTER //
// ./src/service/newsletter.js